<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      allowtransparency
      v-iframe-resize="{ log: true }"
    ></iframe>
  </div>
</template>

<script>
export default {
  computed: {
    url() {
      const user = this.$store.state.AsUser.nom === ""
        ? this.$store.state.user
        : this.$store.state.AsUser;
      if (!user || !user.id_role) { return ""; }
      const dashboard = user.id_role === 1
        ? "public/dashboard/5eccd3de-e4e3-47e1-a610-ec24550a5def"
        : "public/dashboard/318da1e0-82af-4199-b0f3-97e57f115972";
      let param = "";
      if (user.id_role === 2 && user.type === "itinerant") {
        param = "?itinerant=";
      } else if (user.id_role === 2 && user.type === "sedentaire") {
        param = "?sedentaire=";
      }
      const name = user.id_role === 2 ? user.nom : "";
      const hide = user.id_role === 2 ? "#hide_parameters=itinerant,sedentaire,fournisseur" : "";
      return process.env.VUE_APP_REPORTING_URL + dashboard + param + name + hide;
    },
  },
};
</script>
